<template>
  <div class="contacts-link">
    <span class="type">
      {{ contact.displayType }}
    </span>
    <a :href="contact.url">
      {{ contact.displayName }}
    </a>
  </div>
</template>

<script>
  export default {
    name: 'ContactsLink',

    props: [
      'contact',
      'type',
    ],
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .contacts-link {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &+& {
      margin-top: 5vh;

      @media @vertical {
        margin-top: 5vw;
      }
    }
  }

  .type {
    color: @colors[soft];

    @media @mobile-vertical {
      font-size: @font-sizes-mv[normal] * 1.25;
    }
  }

  a {
    .link();
    font-size: 2.75vh;

    @media @vertical {
      font-size: 2.75vw;
    }

    @media @mobile-vertical {
      font-size: @font-sizes-mv[normal] * 1.5;
    }
  }
</style>
